import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button from '../../../../components/shared/Button/Button';
import { createStripeUser } from '../../../../redux/actions/stripeActions';
import urls from '../../../../routing/urls';

import styles from './PaymentInformation.module.scss';

const PaymentInformation = ({ isExperientialPaymentInfoAdded }) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div className={styles.container}>
      <p className={`${styles.text} ${styles.textBold}`}>{t('payments.addPaymentInfo')}</p>
      <div className={styles.divider} />
      <div className={styles.infoCont}>
        <p className={styles.text}>{t('payments.paymentInfoRequiredDescription')}</p>
        <Button
          variant="primary"
          className={styles.btn}
          onClick={
            isExperientialPaymentInfoAdded
              ? () => dispatch(createStripeUser(() => navigate(urls.payments)))
              : () => navigate(urls.experientialRewardsDetails)
          }
        >
          {t('buttons.addPaymentInfo')}
        </Button>
      </div>
    </div>
  );
};

export default PaymentInformation;
